<template>
  <div id="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <img class="w-100 h-100" :src="`http://www.waternaida.com/${banner}`" alt />
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/product/mb_product_banner.png" alt />
    </div>
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_item" separator-class="el-icon-arrow-right">
        <span>
          <i class="el-icon-minus"></i> Current position：
        </span>
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>PRODUCT</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main row">
      <div class="main_left col-lg-3 col-md-12 col-sm-6 el-col-xs-12 w-100">
        <div class="main_left1 w-100">
          <div class="w-100">
            <img class="w-100" src="../img/product/Product_left1.png" alt />
          </div>
          <div class="main_left_txt mt-4 pb-4">
              <!-- 手机端 -->
            <el-collapse v-model="activeNames" @change="handleChange" class="collapse">
              <el-collapse-item title="all categories" name="1">
                <div class="main_left_item row" v-for="(item,index) in product_class" :key="index">
                    <!-- <i class="el-icon-arrow-right col-1 mt-1"></i> -->
                    <router-link class="col-11 main_left_item_txt" :to="{path:'/product',query:{id:item.id}}">
                        <a href="javascript:;" @click="addClass(index)" v-bind:class="{ischeck:index==current}">{{item.name}}</a>
                    </router-link>
                    <i v-show="el_right" @click="addClass(index);navClick(index);iconClick(index)" class="el-icon-plus col-1 mt-1"></i>
                    <div v-show="cindex===index&&navClass" v-for="(nav,i) in (product_class[index].nav)" :key="i" class="w-100 product_sub" >
                        <router-link class="col-11 main_left_item_txt main_left_item_txt_nav" :to="{path:'/product',query:{id:nav.id}}" :class="{'ischedk':mmd}"><a href="javascript:;" @click="addClass(index)">{{nav.name}}</a>}</router-link>
                    </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <!-- 电脑端 -->
            <div class="main_left_item collapse1 row" v-for="(item,index) in product_class" :key="index">
                <router-link class="col-11 main_left_item_txt" :to="{path:'/product',query:{id:item.id}}">
                    <a href="javascript:;" @click="addClass(index);navClick(index)" v-bind:class="{ischeck:index==current}">{{item.name}}</a>
                </router-link>
                <!-- @click="addClass(index);navClick(index)" -->
                <i v-show="el_right" @mouseenter="addClass();navClick(index)" class="el-icon-plus col-1 mt-1"></i>
                <div v-show="cindex===index&&navClass" v-for="(nav,i) in (product_class[index].nav)" :key="i" class="w-100 product_sub" >
                    <router-link class="col-11 main_left_item_txt main_left_item_txt_nav" :to="{path:'/product',query:{id:nav.id}}" :class="{'ischedk':mmd}">{{nav.name}}</router-link>
                </div>
            </div>
          </div>
        </div>
        <div class="main_left2 w-100 mt-3">
          <div class="w-100">
            <img class="w-100" src="../img/product/Product_left2.png" alt />
          </div>
          <div class="main_left_txt mt-4 main_left_contact">
            <div class="main_left_item row">
              <i class="el-icon-location-outline col-1 mt-1"></i>
              <span
                class="col-11 main_left_item_txt"
                href="javascript:;"
              >Address：No.28,Xingbin Road,Sino-Italy Ningbo Ecological Park,Yuyao,Zhejiang,China</span>
            </div>
            <div class="main_left_item row">
              <i class="el-icon-phone-outline col-1 mt-1"></i>
              <a class="col-11 main_left_item_txt" href="javascript:;">TEL：(0086)574 62096133</a>
            </div>
            <div class="main_left_item row">
              <i class="el-icon-document col-1 mt-1"></i>
              <a class="col-11 main_left_item_txt" href="javascript:;">FAX：(0086)574 62096121</a>
            </div>
            <div class="main_left_item row pb-5">
              <i class="el-icon-message col-1 mt-1"></i>
              <span class="col-11 main_left_item_txt" href="javascript:;" style="cursor:default;">E-mail：<p>sales@waternaida.com</p><p>service@waternaida.com</p></span>
            </div>
          </div>
        </div>
      </div>
      <hot class="pp1"></hot>
      <hotMi class="pp2"></hotMi>
    </div>
    <myfooter></myfooter>
  </div>
</template>
<style scoped>
.main {
  width: 80%;
  margin: 0 auto;
  height: 100%;
}
.pp2 {
  display: none !important;
}
.main_right_link_txt {
  color: white;
}
.main_download1_pag {
  width: 100%;
  text-align: right;
}
.main_right_link {
  background: black;
  position: absolute;
  z-index: 999;
  top: 0;
  bottom: 0;
  opacity: 0;
}
.main_right_link:hover {
  opacity: 0.3;
}
.header-bj {
  margin-top: 40px;
}
.main_right {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  padding-right: 1%;
  padding-left: 1%;
}
.main_right_item {
  padding-bottom: 15px;
  padding-right: 10px;
  padding-left: 10px;
  display: flex;
}
.main_right_item > div {
  box-shadow: 0px 1px 5px #888888;
  height: 100%;
  display: block;
  position: relative;
}
.main_right_item > div > span {
  display: block;
}
.main_right_item:hover > div > span {
  display: none;
}
.main_left_item {
  box-sizing: border-box;
}
.main_left_item_txt {
  text-align: left;
  padding: 0;
  color: gray;
  font-size: 1em;
  box-sizing: border-box;
}
.main_left_item_txt > a {
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
}
.main_left_item_txt > a:hover {
  border-bottom: 1px solid cornflowerblue;
  color: cornflowerblue;
  box-sizing: border-box;
}
.main_left_item_txt_nav{
  width: 100%;
  font-size: 0.8rem;
  display: block;
  margin-left: 10%;
  margin-top: 2%;
}
.main_left_item_txt_nav:hover {
  border-bottom: 1px solid cornflowerblue;
  color: cornflowerblue;
  box-sizing: border-box;
}
.main_left_item > i {
  padding-left: 0;
}
.main_left_item > a {
  text-decoration: none;
}
.main_left_txt {
  width: 90%;
  margin: 0 auto;
}
.main_left_txt .main_left_item:nth-child(2) > a > a{
    color: red;
}
.main_left1 {
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 1px 5px #888888;
  padding: 0;
}
.main_left2 {
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 1px 5px #888888;
  padding: 0;
}
.main_left2 .main_left_item:nth-child(2) a{
    color: gray!important;
}
.main_left_item {
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  margin-left: 0;
}
.main_left_item:hover {
  color: cornflowerblue;
  box-sizing: border-box;
}
.main_left {
  padding-left: 1%;
  padding-right: 1%;
}
.main_left_item a {
  text-decoration: none;
  color: gray;
  /* text-transform: uppercase; */
}
.main_left_item a span{
    display: block;
}
.main_left_contact .main_left_item{
    display: block;
    overflow: hidden;
}
.main_left_contact .main_left_item > i{
    float: left;
}
.main_left_contact .main_left_item_txt{
    float: left;
}
.main_left_contact .main_left_item_txt p{
    display: block;
}
.Breadcrumb {
  /* background: lightblue; */
  display: block;
  width: 80%;
  margin: 0 auto;
  /* float: right; */
  margin-bottom: 100px;
}
.Breadcrumb_item > span {
  float: left;
  display: block;
}
.Breadcrumb_item {
  float: right;
  /* background-color: lightcoral; */
}
.ischeck {
  border-bottom: 1px solid cornflowerblue;
}
.ischedk{
  color: blue;
}
@media screen and (max-width:1400px){
    .main_left_item {
        font-size: 0.85rem;
    }
}
@media screen and (max-width: 1200px) {
  .main {
    width: 90%;
    margin: 0 auto;
    height: 100%;
  }
  .header-bj {
    margin-top: 0px;
  }
}
@media screen and (max-width: 992px) {
  .pp1 {
    display: none !important;
  }
  .pp2 {
    display: flex !important;
  }
}
@media screen and (max-width: 768px) {
  .main {
    width: 98%;
    margin: 0 auto;
    height: 100%;
  }
  .Breadcrumb {
    float: left;
  }
  .Breadcrumb_item {
    float: left;
  }
  .collapse1 {
    display: none;
  }
  .collapse {
    display: block !important;
  }
  .main_left2 {
    display: none;
  }
  .main_left {
    margin-bottom: 10%;
  }
  .Breadcrumb_item {
    float: left;
    padding: 20px 15px;
  }
  .Breadcrumb {
    width: 100%;
    margin-bottom: 0;
  }
  .el-collapse-item__header {
    font-size: 18px;
  }
  .main_left_item a {
    font-size: 14px;
  }
  .main_left_txt >>> .el-collapse-item__header {
    font-size: 16px;
  }
  .header-bj {
    margin-top: 0px;
  }
  .main_left_txt .main_left_item:nth-child(1) a {
    color: red;
    }
    .main_left_txt .main_left_item:nth-child(2) a {
    color: gray!important;
}
.product_sub a{
    color: gray!important;
}
}
</style>
<script>
import myfooter from "./zzj/footer";
import myheader from "./zzj/header";
import hot from "./zzj/ppp";
import hotMi from "./zzj/pppM";
import domestic from "./zzj/domestic";
import WOW from "wowjs";
export default {
  data() {
    return {
      comName: "hot",
      product_class: [],
      product_class_nav: [],
      banner: [],
      current: "",
      activeNames: ["0"],
      navClass: false,
      cindex: -1,
      el_right:true,
      el_down:false,
      mmd:true,
      test: true
    };
  },
  components: {
    myfooter: myfooter,
    myheader: myheader,
    hot: hot,
    hotMi: hotMi,
    domestic: domestic
  },
  methods: {
    item_href() {
      this.$router.push({ path: "/product_item" });
    },
    addClass: function(index) {
      this.current = index;
      this.activeNames = "0";
    },
    handleChange(val) {
      console.log(val);
    },
    navClick(index) {
      this.navClass = !this.navClass;
      this.cindex = index;
    },
    iconClick: function(index) {
      this.activeNames = "1";
    },
  },
  created() {
    this.axios
      .get("/api/product/classify")
      .then(res => {
        this.product_class = res.data.classifyList;
        console.log(this.product_class);
      })
      .catch(err => {
        console.log(err);
      });

    this.axios
      .get("/api/banner/index?categoryID=16&language=1")
      .then(res => {
        this.banner = res.data.imgList[0].image;
        console.log(this.banner);
      })
      .catch(err => {
        console.log(err);
      });
  },
  watch: {
    addClass: function(index) {
      this.current = index;
    }
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      mobile: true,
      live: true
    });
    wow.init();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/product.vue